export default "__VITE_ASSET__wTrC2eks__"